import { render, staticRenderFns } from "./ThreeCompositionBox.vue?vue&type=template&id=3b6850be&scoped=true&"
import script from "./ThreeCompositionBox.vue?vue&type=script&lang=js&"
export * from "./ThreeCompositionBox.vue?vue&type=script&lang=js&"
import style0 from "./ThreeCompositionBox.vue?vue&type=style&index=0&id=3b6850be&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6850be",
  null
  
)

export default component.exports